import React, { useState, useReducer } from "react"
import * as styles from "./Styles/CrowdLampSwitch.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import Icon from "../Utils/Icon"
import { CrowdLampSwitchProps } from "./types"
import TrafficLightWidget from "../Common/TrafficLightWidget"
import { RequestHandler } from "../Utils/request_handler"
import { Form, Button } from "react-bootstrap"
import DefaultPreview from "../../images/default_preview.png"

const LampSwitch: React.FC<CrowdLampSwitchProps> = (props) => {
  const path = {
    green: `${props.params.path}?color=green`,
    yellow: `${props.params.path}?color=yellow`,
    red: `${props.params.path}?color=red`,
    turnedOff: `${props.params.path}?color=turnedOff`,
  }

  const activeColor = props.params.active ? props.params.active.color : null

  return (
    <React.Fragment>
      <div className={cn("l-flex", "controls")}>
        <div className={cn("l-flex", "buttons")}>
          <a className={styles.link} href={path.green}>
            <div
              className={cn([
                "l-centering",
                "lampButton",
                "lampButton--green",
                { active: activeColor == null || activeColor == "green" },
              ])}
            >
              空き
            </div>
          </a>
          <a className={styles.link} href={path.yellow}>
            <div
              className={cn([
                "l-centering",
                "lampButton",
                "lampButton--yellow",
                { active: activeColor == null || activeColor == "yellow" },
              ])}
            >
              やや混み
            </div>
          </a>
          <a className={styles.link} href={path.red}>
            <div
              className={cn([
                "l-centering",
                "lampButton",
                "lampButton--red",
                { active: activeColor == null || activeColor == "red" },
              ])}
            >
              混み
            </div>
          </a>
        </div>
        <div className={cn("l-centering", "trafficLightWrapper")}>
          <TrafficLightWidget
            width={160}
            currentColor={activeColor || "turnedOff"}
          />
          {activeColor != null && (
            <div className={styles.activeLamp}>
              <div>
                <span className={styles.limit}>
                  {props.params.active.endedAt}まで
                </span>
                <span>表示されています</span>
              </div>
              <div>
                <a href={path.turnedOff}>取り消す</a>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.annotation}>
        <div className={styles.annotationHeader}>
          <Icon className={styles.infoIcon} type="feather" name="info" />
          <span>混雑ランプとは</span>
        </div>
        <div>
          施設の現在の混雑状況をお知らせする機能です。ボタンを押してから1時間有効となり、いつでもこの画面から取り消すことができます。
        </div>
      </div>
    </React.Fragment>
  )
}

const DefaultCheck = (props) => {
  const [checked, setChecked] = useState(props.params.default ? true : false)

  const toggleDefaults = async (_checked: boolean) => {
    setChecked(_checked)
    const handler = new RequestHandler(props.params.defaultPath, "POST", {
      checked: _checked,
    })
    const res = await handler.requestWithBody()
    if (res.status == 500) {
      alert("エラーが発生しました。しばらく置いてから再度お試しください。")
    }
  }

  return (
    <Form.Check
      type="checkbox"
      id="default-check"
      label="常に「空き」を点灯"
      checked={checked}
      onChange={async (e) => {
        await toggleDefaults(e.target.checked)
      }}
    />
  )
}

const REMARK_MAX_LENGTH = 20
const Remark = (props) => {
  const [remark, dispatchRemark] = useReducer(
    (before, action) => {
      const disabled =
        action.text === props.remark ||
        REMARK_MAX_LENGTH - action.text.length < 0

      return {
        ...before,
        disabled: disabled,
        text: action.text || "",
        count: action.text.length,
      }
    },
    {
      text: props.remark || "",
      disabled: true,
      count: (props.remark || "").length,
    }
  )

  return (
    <Form action={props.path} method="POST">
      <Form.Control
        type="text"
        placeholder="例: 「混み」の場合は入場規制を行っています"
        name="remark"
        value={remark.text}
        className={styles.remarkForm}
        onChange={(e) => {
          dispatchRemark({ text: e.target.value })
        }}
      />
      <div
        className={cn(
          "remarkLength",
          REMARK_MAX_LENGTH - remark.count < 0 ? "remarkLength--error" : ""
        )}
      >
        あと{REMARK_MAX_LENGTH - remark.count}文字
      </div>
      <input type="hidden" name="authenticity_token" value={props.token} />
      <Button
        className="l-primary-button--admin"
        type="submit"
        disabled={remark.disabled}
      >
        保存する
      </Button>
    </Form>
  )
}

const CrowdLampSwitch: React.FC<CrowdLampSwitchProps> = (props) => {
  return (
    <div className="l-section-background--admin">
      <div className={styles.section}>
        <div className={styles.left}>混雑ランプ</div>
        <div className={styles.right}>
          <LampSwitch {...props} />
        </div>
      </div>
      {props.params.remarkAvailable && (
        <React.Fragment>
          <hr className={styles.separator} />
          <div className={styles.section}>
            <div className={styles.left}>ランプの備考</div>
            <div className={styles.right}>
              <Remark
                path={props.params.remarkPath}
                remark={props.params.remark}
                token={props.params.token}
              />
            </div>
          </div>
        </React.Fragment>
      )}
      <hr className={styles.separator} />
      <div className={styles.section}>
        <div className={styles.left}>常時点灯設定</div>
        <div className={styles.right}>
          <div className={styles.defaultAnnotation}>
            <DefaultCheck {...props} />
            <span>※ 設定された営業時間外は点灯しません</span>
          </div>
          <div className={styles.defaultPreview}>
            <span>表示イメージ</span>
            <img src={DefaultPreview} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CrowdLampSwitch
